import { ActionIcon, Menu } from "@mantine/core";
import { MouseEventHandler, useMemo } from "react";

import { IconDots } from "@tabler/icons-react";
import { filter } from "lodash";

interface DropdownOptionsProps {
  options?: {
    children: React.ReactNode | string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
  }[];
  className?: string;
}

export default function DropdownOptions({ options, className }: DropdownOptionsProps) {
  const options_ = useMemo(() => filter(options, Boolean), [options]);
  return (
    <Menu position="bottom-end">
      <Menu.Target>
        <ActionIcon size="xl" pos="absolute" top="2rem" right="3rem" data-testid="dropdown-options">
          <IconDots size={20} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown className={className}>
        {options_.map(({ onClick, children }, index) => (
          <Menu.Item key={index} onClick={onClick}>
            {children}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
